import { Components, Theme } from "@mui/material";

export const components: Components<Omit<Theme, "components">> = {
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }) => ({
        "&.Mui-selected": {
          backgroundColor: theme.palette.table.selected,
        },
        "&.MuiTableRow-hover": {
          ":hover": {
            backgroundColor: theme.palette.table.hover,
          },
        },
        height: "50px",
      }),
    },
  },
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: "48px",
        // "&.Mui-selected": {
        //   backgroundColor: theme.palette.table.selected,
        // },
        borderRadius: "5px",
        "&.Mui-disabled": {
          color: "rgba(0, 0, 0, 0.5)",
        },
      }),
    },
  },
  MuiMenu: {
    defaultProps: {
      slotProps: {
        paper: {
          sx: {
            backgroundColor: (theme) => theme.palette.background.default,
          },
        },
      },
    },
  },
  MuiAccordion: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "12px",
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        textTransform: "capitalize",
      },
    },
  },
  MuiTypography: {
    variants: [
      {
        props: { variant: "subtitle2" },
        style: {
          textTransform: "capitalize",
        },
      },
      {
        props: { variant: "subtitle1" },
        style: {
          textTransform: "capitalize",
        },
      },
      {
        props: { variant: "h7" },
        style: {
          textTransform: "capitalize",
        },
      },
      {
        props: { variant: "h6" },
        style: {
          textTransform: "capitalize",
        },
      },
    ],
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        textTransform: "capitalize",
      },
    },
  },
};
